import { useDispatch, useSelector } from "react-redux";
import { selectNavigation, selectToast } from "../redux/selectors";
import PropTypes from "prop-types";
import CustomFooter from "../components/Footer";
import Header from "../components/Header";
import useNavigationRoutes from "../hooks/useNavigationRoutes";
import HiFiWrapper from "../components/HiFiWrapper";
import ErrorFooter from "../components/ErrorFooter";
import Toast from "../components/Toast";
import { handleCloseToast } from "../redux/Slice/toastSlice";

const Main = ({ actualScreen }) => {
  const { SCREEN_MAP } = useNavigationRoutes();
  const navigation = useSelector(selectNavigation);
  const currentScreen = navigation?.currentScreen || actualScreen;
  const screenConfig = SCREEN_MAP[currentScreen];
  const toastConfigs = useSelector(selectToast);
  const dispatch = useDispatch();

  if (!screenConfig) {
    return null;
  }

  const ScreenComponent = screenConfig.component;

  return (
    <div className={`main ${screenConfig?.isError && 'main-error'}`} data-testid='home-component'>
      {screenConfig?.showHeader && <Header />}
      <Toast {...toastConfigs} onChange={() => dispatch(handleCloseToast())} />
      <div className='home-container'>
        <HiFiWrapper
          title={screenConfig?.modalTitle}
          isError={screenConfig?.isError}
          isModalWhiteSpaceNormal={screenConfig?.isModalWhiteSpaceNormal}
        >
          {ScreenComponent}
        </HiFiWrapper>
      </div>
      {
        screenConfig?.isError ? <ErrorFooter /> : <CustomFooter />
      }
    </div>
  )

}

Main.propTypes = {
  actualScreen: PropTypes.string.isRequired
};

export default Main;